module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#technology",
      toString: function () {
        return this.url;
      }
    }